import { render, staticRenderFns } from "./CVTypeAbilityIntro.vue?vue&type=template&id=36f8cf2a"
import script from "./CVTypeAbilityIntro.vue?vue&type=script&lang=js"
export * from "./CVTypeAbilityIntro.vue?vue&type=script&lang=js"
import style0 from "./CVTypeAbilityIntro.vue?vue&type=style&index=0&id=36f8cf2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports